"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Language cnfiguration convenience wrapper HOC
 * @todo deprecate next major version, replace with hook
 */
var React = require("react");
var types_1 = require("./types");
var withLanguage = function (Component) {
    return /** @class */ (function (_super) {
        __extends(WithLanguageConfigurationContextHOC, _super);
        function WithLanguageConfigurationContextHOC(props) {
            return _super.call(this, props) || this;
        }
        WithLanguageConfigurationContextHOC.prototype.render = function () {
            var props = this.props;
            return (React.createElement(types_1.OuiConfigurationContextConsumer, null, function (_a) {
                var language = _a.language;
                return React.createElement(Component, __assign({}, props, { language: language }));
            }));
        };
        return WithLanguageConfigurationContextHOC;
    }(React.PureComponent));
};
exports.default = withLanguage;
//# sourceMappingURL=languageContextHOC.js.map